export default __webpack_public_path__ + "static/media/weight-loss_wegovy.d7762187.jpg";